export default __webpack_public_path__ + "static/media/com-red.c2a6ae80.svg";